<template>
    <modal name="offline" class="dd-m-modal dd-m-modal--offline">
        <button v-on:click="hide()" type="button" class="dd-m-modal--offline__close-btn">
            <i class="dd-m-icon icon-close"></i>
        </button>

        <div class="dd-m-modal--offline__content">
            <h2 class="dd-m-modal--offline__title">
                Conteúdo<br/>
                disponível offline
            </h2>

            <div class="dd-m-modal--offline__description">
                Download the content and see the app even when you're offline.
            </div>

            <button type="button"
                    v-on:click="hide()"
                    class="dd-m-button dd-m-button--default dd-m-button--assertive">
                Baixar
            </button>
        </div>
    </modal>
</template>
<script>
    export default {
        name: 'modal-offline',
        mounted() {
            PubSub.subscribe('openOfflineModal', () => this.show());
        },
        methods: {
            show() {
                this.$modal.show('offline');
            },
            hide() {
                this.$modal.hide('offline');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/custom-modals/modal-offline.vue